import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default function Services() {
  const { data } = useStaticQuery(graphql`
    {
      data: allMarkdownRemark(
        filter: { frontmatter: { type: { eq: "service" } } }
        sort: { fields: frontmatter___weight }
      ) {
        edges {
          node {
            id
            html
            frontmatter {
              title
              image {
                childImageSharp {
                  fluid(maxWidth: 546, maxHeight: 651, quality: 80) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  console.log("data", data)

  return (
    <div className="c-services">
      <div className="u-inner">
        <div className="o-grid o-grid--spaced-large@portable">
          {data.edges.map(({ node }, index) => {
            return (
              <div key={node.id} className="o-grid__cell u-1/1 u-1/3@desktop">
                <div className="c-service">
                  <h2 className="c-service__title">
                    0{index + 1}—
                    <br />
                    {node.frontmatter.title}
                  </h2>
                  <Img fluid={node.frontmatter.image.childImageSharp.fluid} />
                  <div
                    className="c-service__content"
                    dangerouslySetInnerHTML={{ __html: node.html }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
